import axios from 'axios';
import router from '../Routes';
import {authtoken} from '@/values/private';
import {mapActions} from "vuex";

export default {
  namespaced: true,
  state: {
    isChangePassword: false,
    isChangeDone: false,
    isFetching: false,
    hasAlert: false,
    errorMessage: '',
    userrole: null,
  },
  methods: {
    ...mapActions('Chat', ['clear']),
  },
  mutations: {
    CHANGE_USER_PASSWORD_REQUEST(state) {
      state.isFetching = true;
      state.hasAlert = false;
      state.errorMessage = '';
    },
    CHANGE_USER_PASSWORD_FAILURE(state, payload) {
      state.isFetching = false;
      state.hasAlert = true;
      state.errorMessage = payload.error;
    },
    CHANGE_USER_PASSWORD_SUCCESS(state) {
      state.isChangeDone = true,
      state.isChangePassword = false,
      state.isFetching = false;
      state.hasAlert = false;
      state.errorMessage = '';
    },
    LOGIN_REQUEST(state) {
      state.isFetching = true;
      state.hasAlert = false;
      state.errorMessage = '';
    },
    LOGIN_FAILURE(state, payload) {
      state.isFetching = false;
      state.hasAlert = true;
      state.errorMessage = payload;
    },
    LOGIN_SUCCESS(state) {
      state.isFetching = false;
      state.errorMessage = '';
    },
    RESET_USER_PASSWORD_REQUEST(state) {
      state.isFetching = true;
      state.hasAlert = false;
      state.errorMessage = '';
    },
    RESET_USER_PASSWORD_SUCCESS(state) {
      state.isFetching = false;
      state.isChangePassword = true;
    },
    RESET_USER_PASSWORD_FAILURE(state, payload) {
      state.isFetching = false;
      state.hasAlert = true;
      state.errorMessage = payload.error;
    },
    RESET_PASSWORD_CLEAR(state) {
      state.isChangePassword = false;
      state.isChangeDone = false;
      state.isFetching = false;
      state.hasAlert = false;
      state.errorMessage = '';
    }
  },
  actions: {
    ...mapActions('Chat', ['clear']),
    clearResetUserPassword({commit}){
      commit('RESET_PASSWORD_CLEAR');
    },
    loginUser({dispatch}, payload) {
      dispatch('loginRequest');
      let url = 'https://api.accountxc.com:3100/authentication/login';
      let headers = {'Content-Type': 'application/json', 'authtoken': authtoken};
      let data = {useremail: payload.email, userpassword: payload.password, companyid: payload.companyid};
      axios({method: "post",url: url, headers: headers, data: data})
      .then(response => {
        dispatch('loginReceiveAuth', response.data);
      })
      .catch(error => {
        console.log(error)
        dispatch('loginFailure', error.response.data.error);
      })
    },
    resetUserPassword({dispatch}, payload) {
      dispatch('resetUserPasswordRequest');
      let url = 'https://api.accountxc.com:3100/authentication/resetpassword/';
      let headers = {'Content-Type': 'application/json', 'authtoken': authtoken};
      let data = {useremail: payload.email, companyid: payload.companyid};
      console.log(data);
      axios({method: "post", url: url, headers: headers, data: data})
      .then(() => {
        dispatch('resetUserPasswordSuccess');
      })
      .catch(error => {
        dispatch('resetUserPasswordFailure', error.response.data);
      });
    },
    changeUserPassword({dispatch}, payload) {
      dispatch('changeUserPasswordRequest');
      let url = 'https://api.accountxc.com:3100/authentication/changepassword/';
      let header = {'Content-Type': 'application/json', 'authtoken': authtoken};
      axios({method: "post", url: url, headers: header, data: payload})
      .then(()=> {
        dispatch('changeUserPasswordSuccess');
      })
      .catch(error => {
        dispatch('changeUserPasswordFailure', error.response.data);
      });
    },
    loginReceiveAuth({dispatch}, payload) {
      localStorage.setItem('isLogout', false);
      localStorage.setItem('token', payload.accesstoken);
      localStorage.setItem('roleid', payload.roleid);
      localStorage.setItem('userid', payload.userid);  
      localStorage.setItem('username', payload.username);      
      localStorage.setItem('useremail', payload.useremail);
      localStorage.setItem('userimage', payload.userimage);
      localStorage.setItem('useraccess', JSON.stringify(payload.useraccess));
      localStorage.setItem('usermenus', JSON.stringify(payload.usermenus));
      localStorage.setItem('companyid', payload.companyid);
      localStorage.setItem('companyname', payload.companyname);
      localStorage.setItem('companycode', payload.companycode);
      localStorage.setItem('employeeid', payload.employeeid);
      axios.defaults.headers.common['Authorization'] = "Bearer " + payload.token;
      dispatch('loginSuccess');
    },
    logoutUser() {
      localStorage.setItem('isLogout', true);
      localStorage.removeItem('token');
      localStorage.removeItem('roleid');
      localStorage.removeItem('userid');
      localStorage.removeItem('username');
      localStorage.removeItem('useremail');
      localStorage.removeItem('userimage');
      localStorage.removeItem('useraccess');
      localStorage.removeItem('usermenus');
      localStorage.removeItem('companyid');
      localStorage.removeItem('companyname');
      localStorage.removeItem('companycode');
      localStorage.removeItem('employeeid');
      document.cookie = 'token=;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
      axios.defaults.headers.common['Authorization'] = "";
      router.push('/login');
    },
    changeUserPasswordRequest({commit}) {
      commit('CHANGE_USER_PASSWORD_REQUEST');
    },
    changeUserPasswordFailure({commit}, payload) {
      commit('CHANGE_USER_PASSWORD_FAILURE', payload);
    },
    changeUserPasswordSuccess({commit}, payload) {
      commit('CHANGE_USER_PASSWORD_SUCCESS', payload);
    },
    loginRequest({commit}) {
      commit('LOGIN_REQUEST');
    },
    loginSuccess({commit}) {
      commit('LOGIN_SUCCESS');
      router.push('/dashboard');
    },
    loginFailure({commit}, payload) {
      commit('LOGIN_FAILURE', payload);
    },
    resetUserPasswordRequest({commit}) {
      commit('RESET_USER_PASSWORD_REQUEST');
    },
    resetUserPasswordSuccess({commit}) {
      commit('RESET_USER_PASSWORD_SUCCESS');
    },
    resetUserPasswordFailure({commit}, payload) {
      commit('RESET_USER_PASSWORD_FAILURE', payload);
    },
  }
}
